<template>
    <div class="see" :class="transitionShow">
        <video
                id="myVideo"
                muted
                loop
                playsinline
        ></video>
        <canvas id="myCanvas" width="200"/>
    </div>
</template>

<script>
    import * as faceapi from "face-api.js";

    export default {
        name: "WebRTCFaceDetector",
        props:{
            faceShowType:Boolean
        },
        data() {
            return {
                nets: "tinyFaceDetector", // 模型
                options: null, // 模型参数
                detectFace: "detectAllFaces", // 单or多人脸
                videoEl: null,
                canvasEl: null,
                timeout: 0,
                // 视频媒体参数配置
                constraints: {
                    audio: false,
                    video: {
                        width: window.innerWidth,
                        height: window.innerHeight,
                        // ideal（应用最理想的）
                        /*  width: {
                              min: 320,
                              ideal: 1280,
                              max: 1920,
                          },
                          height: {
                              min: 240,
                              ideal: document.body.clientHeight,
                              max: 1080,
                          },*/
                        // frameRate受限带宽传输时，低帧率可能更适宜
                        frameRate: {
                            min: 15,
                            ideal: 30,
                            max: 60,
                        },
                        // 显示模式前置后置
                        facingMode: "user",//user--前置摄像头，environment--后置
                    },
                },
                transitionShow: 'default',//默认不显示摄像头界面
                faceTime: null,//识别出人脸的时间
                faceNum:0,//第几个识别到人脸
                httpTimers:null,//发送请求定时器
            };
        },
        watch: {
            nets(val) {
                this.nets = val;
                this.fnInit();
            },
            faceShowType(val){
                if(val){
                    this.fnInit();
                    this.transitionShow = 'a-fadein';
                }
            },
            faceNum(val){
                if(val){
                    if(!this.httpTimers){
                        this.httpTimers=setTimeout(() => {
                            this.setImage();
                            clearTimeout(this.httpTimers);
                            this.httpTimers=null;
                        },5000);
                    }

                }
            }
        },
        mounted() {},
        methods: {
            // 初始化模型加载
            async fnInit() {
                await faceapi.nets[this.nets].loadFromUri("./models");
                await faceapi.loadFaceLandmarkModel("./models"); // 轮廓模型
                // 根据模型参数识别调整结果
                switch (this.nets) {
                    case "ssdMobilenetv1":
                        this.options = new faceapi.SsdMobilenetv1Options({
                            minConfidence: 0.5, // 0.1 ~ 0.9
                        });
                        break;
                    case "tinyFaceDetector":
                        this.options = new faceapi.TinyFaceDetectorOptions({
                            inputSize: 512, // 160 224 320 416 512 608
                            scoreThreshold: 0.5, // 0.1 ~ 0.9
                        });
                        break;
                    case "mtcnn":
                        this.options = new faceapi.MtcnnOptions({
                            minFaceSize: 20, // 0.1 ~ 0.9
                            scaleFactor: 0.709, // 0.1 ~ 0.9
                        });
                        break;
                }
                // 节点属性化
                this.videoEl = document.getElementById("myVideo");
                this.canvasEl = document.getElementById("myCanvas");
                // this.canvasEl.width=1000;
                this.fnOpen();
            },
            // 节点对象执行递归识别绘制
            async fnRun() {
                console.log("Run");
                // 识别绘制人脸信息
                const result = await faceapi[this.detectFace](this.videoEl, this.options).withFaceLandmarks();
                if (result && !this.videoEl.paused) {
                    // this.imgRemove();
                    const dims = faceapi.matchDimensions(
                        this.canvasEl,
                        {width: this.constraints.video.width, height: this.constraints.video.height},
                        true);
                    const resizeResult = faceapi.resizeResults(result, dims);
                    this.faceNum=resizeResult.length;
                    if (resizeResult.length) {
                        if(this.faceShowType){
                            // faceapi.draw.drawDetections(this.canvasEl, resizeResult);
                            // faceapi.draw.drawFaceLandmarks(this.canvasEl, resizeResult);//轮廓
                            //删除多余的识别框框
                            let dom = document.querySelectorAll('div.faceImg');
                            // console.log(dom.length,"----",resizeResult.length)
                            if(dom.length>resizeResult.length){
                                for (let i=0;i<dom.length;i++){
                                    if(i>=resizeResult.length){
                                        console.log(dom[i])
                                        dom[i].parentNode.removeChild(dom[i]);
                                    }
                                }
                            }
                            resizeResult.forEach((result,index) => {

                                /*new faceapi.draw.DrawBox(
                                    result.detection.box,
                                    {
                                        boxColor:'#66E8F6',
                                        lineWidth:'6',
                                        drawLabelOptions:{
                                            // anchorPosition:{x:result.detection.box.bottom},
                                            backgroundColor:'#66E8F6',
                                            fontSize:'30'
                                        },
                                        label:(((result.detection.score).toFixed(2))*100)+'%'
                                    },
                                ).draw(this.canvasEl);*/
                                /*let html='<div class="faceImg" style="position:absolute;left:'+(result.detection.box.left)+'px;'+'top:'+(result.detection.box.top-100)+'px;'+'z-index:500"" >' +
                                    '<p style="width:'+(result.detection.box.width)+'px;text-align:center;'+'font-size: 40px;color: #6591F5;">'+(((result.detection.score).toFixed(2))*100)+'%'+'</p>' +
                                    '<img style="width:'+(result.detection.box.width)+'px;'+'height:'+result.detection.box.height+'px;"" src="'+require('@/assets/img/face.png')+'" >' +
                                    '</div>'
                                document.body.insertAdjacentHTML('beforeend',html);*/

                                if(dom.length && dom[index]){
                                    let num=(result.detection._score *100).toString().substr(0,2);
                                    let style='position:absolute;left:' + (result.detection._box._x+ (result.detection._box._width/17)) + 'px;top:' + (result.detection._box._y - (result.detection._box._height/2)) + 'px;z-index:500';
                                    dom[index].setAttribute('style',style)
                                    dom[index].setAttribute('x',result.detection._box._x)
                                    dom[index].setAttribute('y',result.detection._box._y)
                                    dom[index].children[0].setAttribute('style','width:' + (result.detection._box._width) + 'px;text-align:center;' + 'font-size: 1.3rem;color: #6591F5;');
                                    dom[index].children[0].innerHTML =(num + '%' ) + '<img style="height:  .5vw !important;width:  2vw !important;" src="'+require('@/assets/img/faceGif.gif')+'" alt="">';
                                    dom[index].children[1].setAttribute('style','width:' + (result.detection._box._width) + 'px;' + 'height:' + result.detection._box._height + 'px;')
                                }else {
                                    this.workerFn(result);
                                }
                            })
                            this.faceTime = new Date();
                        }
                    } else {
                        this.imgRemove();
                        if (((new Date() - this.faceTime) >= 60000) && (this.transitionShow === 'a-fadein')) {
                            this.transitionShow = 'a-fadeout';
                            this.$parent.faceShowType=false;//识别重置为默认
                            this.fnClose();
                            this.$parent.$parent.info();
                        }
                    }
                } else {
                    this.canvasEl
                        .getContext("2d")
                        .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
                }

                this.timeout = setTimeout(() => this.fnRun());
            },
            //画框框
            workerFn(result){
                let worker = this.$worker.run(result => result, [result])
                    .then(res => {
                        let num=(res.detection._score * 100).toString().substr(0,2);
                        // console.log(res)
                        let html = '<div x="' + (res.detection._box._x) + '" y="' + (res.detection._box._y) + '" class="faceImg" style="position:absolute;left:' + (res.detection._box._x + (res.detection._box._width/17)) + 'px;top:' + (res.detection._box._y - (res.detection._box._height/2)) + 'px;z-index:500"" >' +
                            '<p style="width:' + (res.detection._box._width) + 'px;text-align:center;' + 'font-size: 1.3rem;color: #6591F5;">' + num + '%' + '<img style="height: .5vw !important;width:  2vw !important;" src="'+require('@/assets/img/faceGif.gif')+'" alt=""></p>' +
                            '<img style="width:' + (res.detection._box._width) + 'px;' + 'height:' + res.detection._box._height + 'px;"" src="' + require('@/assets/img/face.png') + '" >' +
                            '</div>'
                        document.body.insertAdjacentHTML('beforeend', html);
                    })
                    .catch(e => console.log(e))
                setTimeout(() => {
                    worker = null;
                })
            },
            //删除所有人脸识别的imgdom
            imgRemove() {
                let dom = document.querySelectorAll('div.faceImg');
                for (let i = 0; i < dom.length; i++) {
                    //删除元素 元素.parentNode.removeChild(元素);
                    if (dom[i] != null) {
                        dom[i].parentNode.removeChild(dom[i]);
                    }
                }

            },
            // 启动摄像头视频媒体
            fnOpen() {
                if (typeof window.stream === "object") return;
                navigator.mediaDevices
                    .getUserMedia(this.constraints)
                    .then(this.fnSuccess)
                    .catch(this.fnError);
            },
            // 成功启动视频媒体流
            fnSuccess(stream) {
                window.stream = stream; // 使流对浏览器控制台可用
                this.videoEl.srcObject = stream;
                this.videoEl.onloadedmetadata = (e) => {
                    this.videoEl.play();
                    this.fnRun();
                    this.faceTime = new Date();
                }
            },
            // 失败启动视频媒体流
            fnError(error) {
                console.log(error);
                alert("视频媒体流获取错误" + error);
            },
            // 结束摄像头视频媒体
            fnClose() {
                this.canvasEl
                    .getContext("2d")
                    .clearRect(0, 0, this.canvasEl.width, this.canvasEl.height);
                this.videoEl.pause();
                clearTimeout(this.timeout);
                if (typeof window.stream === "object") {
                    window.stream.getTracks().forEach((track) => track.stop());
                    window.stream = "";
                    this.videoEl.srcObject = null;
                }
            },
            //获取image发送识别请求
            setImage() {
                this.canvasEl
                    .getContext("2d").drawImage(this.videoEl, 0, 0, this.canvasEl.width, this.canvasEl.height)
                // 获取图片base64链接
                var image = this.canvasEl.toDataURL('image/png')
                // console.log(this.imgSrc);
                //发送请求
                let param = new FormData();
                param.append('face', this.dataURLtoFile(image, 'searchFace.png'));
                // console.log( this.dataURLtoFile(this.imgSrc,'searchFace.png'))
                this.$server.pushImgOss(param).then((res) => {
                    // console.log(res.data)
                    if (res.data.data.length) {
                        //调取用户登录信息
                        res.data={
                            time: new Date(),
                            ...res.data
                        }
                        this.userLoginMsg(res.data)
                    }
                }).catch((err) => {

                })
            },
            /**@function  base64转文件
             *****************************************/
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(',')
                var mime = arr[0].match(/:(.*?);/)[1]
                var bstr = atob(arr[1])
                var n = bstr.length
                var u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, {type: mime})
            },
            //登录人员
            userLoginMsg(userData) {
                this.$parent.faceShowType=false;
                this.fnClose();
                if(this.$route.name!='Login'){
                    this.$router.push({
                        path: '/login',
                        name: 'Login',
                        params: userData
                    });
                }
            },
        },
        beforeDestroy() {
            this.faceTime=null;
            let dom = document.querySelectorAll('div.faceImg');
            for (let i = 0; i < dom.length; i++) {
                //删除元素 元素.parentNode.removeChild(元素);
                dom[i].parentNode.removeChild(dom[i]);
            }
        },
    };
</script>

<style scoped>
    .see, video, canvas {
        z-index: 400;
        position: fixed;
        left: 0;
        top: 0;
        display: block;
        /*height: 100%;*/
        object-fit: fill;
    }

    .see, video, canvas {
        width: 100%;
    }

    .default {
        opacity: 0;
    }
</style>
